import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { AuthService } from '../_services/auth.service';
import { TransmissionSystemOperatorResource } from '../_resources/transmission-system-operator.resource';

class ShippersDetailsContactDetailsComponentCtrl implements ng.IController {
    private shipperContactDetails: Shipper;
    private assignment: TsoShipperAssignmentsDto;
    private shipperCountry: string = '';
    private authenticatedUser: LoginResult;
    private tsoCountry: string;
    public loading: boolean;
    public DISPATCHING_CENTRAL: string = 'DISPATCHING_CENTRAL';

    constructor(
        private countryService: any,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private authService: AuthService,
        private COUNTRIES: any,
        private Shipper: any,
        private errorHandler: ErrorHandler
    ) {}

    $onInit() {
        this.loadContactDetails();
    }

    public loadContactDetails(): void {
        this.loading = true;

        this.Shipper.get(
            { id: this.assignment.shipperRefId },
            (res: Shipper) => {
                this.shipperContactDetails = res;
                this.loading = false;
                this.setCountry(this.shipperContactDetails.address);
            },
            (err) => {
                this.loading = false;
                this.errorHandler(err);
            }
        );

        this.authService.userLoginPromise.promise.then((res) => {
            this.authenticatedUser = res;

            this.TransmissionSystemOperator.get(
                { id: this.authenticatedUser.referenceId },
                (res: TsoDto) => {
                    this.tsoCountry = res.address.countryCode;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.errorHandler(err);
                }
            );
        });
    }

    private setCountry(address: AddressDto) {
        if (address != null) {
            this.shipperCountry = this.countryCodeToCountryName(
                this.shipperContactDetails.address.countryCode
            );
        }
    }

    public countryCodeToCountryName(countryCode) {
        if (countryCode != null) {
            return this.countryService.getCountryByCode(
                this.COUNTRIES,
                countryCode
            );
        }
    }
}

angular.module('app').component('pkpShippersDetailsContactDetails', {
    controller: ShippersDetailsContactDetailsComponentCtrl,
    template: require('app/shippers/shippers-details-contact-details.component.html'),
    bindings: {
        assignment: '<'
    }
});
